"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _DEFAULT_LINE_HEIGHTS;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIZES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4'
};
var DEFAULT_LINE_HEIGHTS = (_DEFAULT_LINE_HEIGHTS = {}, _defineProperty(_DEFAULT_LINE_HEIGHTS, SIZES.H1, 20), _defineProperty(_DEFAULT_LINE_HEIGHTS, SIZES.H2, 12), _defineProperty(_DEFAULT_LINE_HEIGHTS, SIZES.H3, 10), _defineProperty(_DEFAULT_LINE_HEIGHTS, SIZES.H4, 8), _DEFAULT_LINE_HEIGHTS);
/**
 * Title component is a wrapper component around the `<h1> to <h4>` html
 * tags with special handling around multiple lines styling.
 */

var Title =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Title, _React$PureComponent);

  function Title() {
    var _this;

    _classCallCheck(this, Title);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).call(this));
    _this.state = {
      // Control the line-height css styling when dealing with multi line
      // text.
      multiLine: false
    };
    return _this;
  }

  _createClass(Title, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkForMultiLine();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkForMultiLine();
    }
  }, {
    key: "checkForMultiLine",
    value: function checkForMultiLine() {
      if (this.props.forceSingleLine) {
        return;
      } // If the height of the element is larger than the line height
      // this means we are dealing with multi lines text.


      if ((0, _ReactElementUtils.getElementHeight)(this.paragraphNode) > DEFAULT_LINE_HEIGHTS[this.props.size]) {
        this.setState({
          multiLine: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // Don't pass forceSingleLine prop to the <H*>tag.
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
          className = _this$props.className,
          size = _this$props.size,
          forceSingleLine = _this$props.forceSingleLine,
          props = _objectWithoutProperties(_this$props, ["className", "size", "forceSingleLine"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var multiLineClass = this.state.multiLine ? "line-multiline-".concat(size) : '';

      var newProps = _objectSpread({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-title"), multiLineClass, className),
        ref: function ref(node) {
          _this2.paragraphNode = node;
        }
      }, props); // size is h1,h2,h3, or h4


      return _react.default.createElement(size, newProps);
    }
  }]);

  return Title;
}(_react.default.PureComponent);

exports.default = Title;
Title.defaultProps = {
  size: SIZES.H1,
  forceSingleLine: false
};
Title.propTypes = {
  /**
   * Additional classname
   *
   * 'dark-bg' : style font color for use in dark background.
   */
  className: _propTypes.default.string,

  /**
   * Title goes here.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Size of the separator.
   */
  size: _propTypes.default.oneOf([SIZES.H1, SIZES.H2, SIZES.H3, SIZES.H4]),

  /**
   * Force using single line styling.
   */
  forceSingleLine: _propTypes.default.bool
};
Title.SIZES = SIZES;